import { combineReducers } from "redux";
import countries from "./countries";
import stateProvinces from "./stateProvinces";

export default combineReducers({
  countries,
  stateProvinces,
});
